import React from 'react'
import Section from './Section'
import Section1 from './Section1'
import Footer from './Footer'
import Navbar4 from '../layout/Navbar4'

const Index5 = () => {
  return (
    <React.Fragment>
        <Navbar4 />
        <Section />
        <Section1 />
        <Footer />
    </React.Fragment>
  )
}

export default Index5